import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings")({
  beforeLoad: ({ context }) => requireRoute(context, "/settings"),
});
